module.exports = __webpack_public_path__ + "img/DSC_1884.0631b3bb.JPG";